/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

export type ChangeLockStatusDtoStatus = typeof ChangeLockStatusDtoStatus[keyof typeof ChangeLockStatusDtoStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChangeLockStatusDtoStatus = {
  LOCKED: 'LOCKED',
  BLUETOOTH_INVERS_UNLOCKING: 'BLUETOOTH_INVERS_UNLOCKING',
  BLUETOOTH_INVERS_LOCKING: 'BLUETOOTH_INVERS_LOCKING',
  UNLOCKED: 'UNLOCKED',
} as const;
